import React, { useEffect } from 'react';
import { ReactComponent as SuccessIcon } from '../../assets/quick-apply-success-icon.svg';
import { Button } from '../../../../../base/components/Button';
import { __t } from '../../../../../base/utils/t';

import './styles.scss';
import { RecommendedVacancies } from '../../../../components/RecommendedVacancies';
import { quickApplyActions } from '../../redux/slices/quickApplySlice';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';

export const ApplySuccess = () => {
    const dispatch = useAppDispatch();
    const { vacancyId, similarVacancies } = useAppSelector((state) => state.workerAppQuickApply);
    const createProfileHandler = () => (window.location.href = '/cv/place');

    useEffect(() => {
        dispatch(quickApplyActions.getSimilarVacancies(vacancyId));
    }, [vacancyId]);

    return (
        <>
            <div className='quick-apply-success'>
                <div className='quick-apply-success__wrapper'>
                    <SuccessIcon className='quick-apply-success__icon' />
                    <h1 className='quick-apply-success__title'>{__t('Работодатель получил ваш отклик')}</h1>
                    <p className='quick-apply-success__text'>
                        {__t('Работодатель свяжется с вами, если его заинтересует ваш отклик.')}
                    </p>
                    <div className='quick-apply-success__banner'>
                        <span className='quick-apply-success__banner-emoji'>🚀</span>
                        <p className='quick-apply-success__banner-text'>
                            {__t(
                                'Создайте анкету, чтобы получать больше выгодных предложений о работе. Большинство работодателей предпочитают работать с нашей базой анкет на сайте.',
                            )}
                        </p>
                        <Button onClick={createProfileHandler} className='quick-apply-success__banner-button'>
                            {__t('Создать анкету')}
                        </Button>
                    </div>
                </div>
            </div>

            {!!similarVacancies.length && <RecommendedVacancies similarVacancies={similarVacancies.slice(0, 4)} />}
        </>
    );
};
